module.exports = __webpack_public_path__ + "static/media/fbtb_t_header.4a99674c.png";